import React, { Fragment, useState, useRef } from 'react'
import { ListItem, Menu, IconButton, Divider } from '@realsoftworks/decor'
import { useHistory, SORT_OPTS, DEFAULT_SORT } from 'search/HistoryContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSortAmountDownAlt } from '@fortawesome/free-solid-svg-icons'

const HistorySort = () => {
  const { sort: selectedSort, setSortAndfetchHistory } = useHistory()
  const ref = useRef()
  const [isOpen, setIsOpen] = useState(false)
  const isActive = selectedSort !== DEFAULT_SORT

  return (
    <>
      <IconButton
        fontSize='22px'
        color={isActive ? 'blue.500' : 'secondary'}
        ref={ref}
        onClick={() => setIsOpen(v => !v)}
      >
        <FontAwesomeIcon icon={faSortAmountDownAlt} />
      </IconButton>
      <Menu
        target={ref.current}
        open={isOpen}
        onClose={() => setIsOpen(null)}
        variant='dense'
      >
        {SORT_OPTS.map((group, i) => (
          <Fragment key={i}>
            {i !== 0 && <Divider style={{ margin: '8px 0' }} />}
            {group.map(({ label, sort }) => (
              <ListItem
                key={sort}
                fontSize={0}
                bg={sort === selectedSort ? 'primary.500' : ''}
                color={sort === selectedSort ? 'white' : ''}
                css={`
                  &:hover {
                    ${sort === selectedSort ? `
                      background-color: #38A1A8;
                    ` : `
                      color: black;
                    `}
                  }
                `}
                onClick={() => {
                  setSortAndfetchHistory(sort)
                  setIsOpen(null)
                }}
              >
                {label}
              </ListItem>
            ))}
          </Fragment>
        ))}
      </Menu>
    </>
  )
}

export default HistorySort
